<div>
    <div *ngIf="selected_coaching_plan_details.name == ''">
      <!-- <div class="coaching-plan-table-section" *ngIf="advisor_plan_table_data_loaded"> -->
      <div class="new-table-v2-overflow" *ngIf="advisor_plan_table_data_loaded">
        <!-- <div class="coaching-plan-table-heading-section">
          <span>Coaching Plans</span>
        </div> -->
        <!-- <table class="coaching-plan-table" *ngIf="advisor_plan_table_data.length > 0"> -->
        <table class="new-table-v2" *ngIf="advisor_plan_table_data.length > 0">
          <thead>
            <tr>
              <!-- <th>Sr.No</th> -->
              <th>S. No</th>
              <th>Coaching Plan</th>
              <th>Activated Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of advisor_plan_table_data; let index = index">
              <td>{{ index + 1 }}</td>
              <td>{{ plan.name }}</td>
              <td>{{ plan.activated_date | date: "dd MMM yyyy" }}</td>
              <td>
                <img
                  src="assets/view-tasks.png"
                  class="client-table-icon"
                  (click)="getSelectedCoachingPlanData(plan)"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="coaching-plan-table-zero-state"
          *ngIf="advisor_plan_table_data.length == 0"
        >
          <span colspan="4">No Coaching Plans Found</span>
        </div>
      </div>
      <div class="manage-plan-loader" *ngIf="!advisor_plan_table_data_loaded">
        <!-- <div class="ring">
            Loading
            <span></span>
          </div> -->
        <app-loader [loading_text]="'Loading'"></app-loader>
      </div>
    </div>
    <div
      class="selected-coaching-plan-section"
      *ngIf="selected_coaching_plan_details.name != ''"
    >
      <div *ngIf="selected_coaching_plan_data_loaded">
        <div class="selected-coaching-plan-heading-section">
          <div class="back-icon-section">
            <img src="assets/back.png" (click)="back()" />
          </div>
          <span>{{ selected_coaching_plan_data.coaching_plan }}</span>
          <!-- <span class="back-link" (click)="back()">Go Back</span> -->
        </div>
  
        <div class="selected-coaching-plan-summary-section">
          <!-- <div class="selected-coaching-plan-details-section">
              <div class="each-coaching-plan-details-section">
                <span class="each-coaching-plan-details-label">Advisors</span>
                <span class="each-coaching-plan-details-count">{{selected_coaching_plan_data.advisors}}</span>
              </div>
              <div class="each-coaching-plan-details-section">
                <span class="each-coaching-plan-details-label">Segment</span>
                <span class="each-coaching-plan-details-count">{{selected_coaching_plan_data.segment}}</span>
              </div>
              <div class="each-coaching-plan-details-section">
                <span class="each-coaching-plan-details-label">Activated Date</span>
                <span class="each-coaching-plan-details-count">{{selected_coaching_plan_data.activated_date | date: 'dd MMM yyyy'}}</span>
              </div>
            </div> -->
          <div class="selected-coaching-plan-notes-section">
            <p class="selected-coaching-plan-notes-heading">Notes</p>
            <p class="selected-coaching-plan-notes">
              {{ selected_coaching_plan_data.notes }}
            </p>
          </div>
        </div>
        <div class="selected-coaching-plan-table-section">
          <table class="selected-coaching-plan-table">
            <thead>
              <tr>
                <th style="width: 50%;">Communication Channel</th>
                <th
                  style="width: 25%;"
                  *ngFor="
                    let header of selected_coaching_plan_data[
                      'comm_advisors_table'
                    ]
                  "
                >
                  {{ header.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let interaction of selected_coaching_plan_data[
                    'interactions_table'
                  ]
                "
              >
                <td style="width: 50%;">
                  {{ interaction.name }}
                </td>
                <td
                  style="width: 25%;"
                  *ngFor="
                    let data of selected_coaching_plan_data[
                      'comm_advisors_table'
                    ];
                    let index = index
                  "
                >
                  <span>{{ interaction[data["id"]]["value"] }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <div class="selected-coaching-plan-table-section">
          <table class="selected-coaching-plan-table">
            <thead>
              <tr>
                <th style="width: 50%;">Sales Performance</th>
                <th
                  style="width: 50%;"
                  *ngFor="
                    let advisor of selected_coaching_plan_data['advisors_table']
                  "
                >
                  {{ advisor.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let performance of selected_coaching_plan_data['sales_table']
                "
              >
                <td style="width: 50%;">
                  {{ performance.name }}
                </td>
                <td
                  *ngFor="
                    let data of selected_coaching_plan_data['advisors_table'];
                    let index = index
                  "
                  style="width: 50%;"
                >
                  <span>{{ performance[data["id"]]["value"] }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <div class="selected-coaching-plan-table-section">
          <table class="selected-coaching-plan-table">
            <thead>
              <tr>
                <th style="width: 50%;">Trainings</th>
                <th
                  style="width: 50%;"
                  *ngFor="
                    let advisor of selected_coaching_plan_data['advisors_table']
                  "
                >
                  {{ advisor.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let trainings of selected_coaching_plan_data['trainings_table']
                "
              >
                <td style="width: 50%;">
                  {{ trainings.name }}
                </td>
                <td
                  *ngFor="
                    let data of selected_coaching_plan_data['advisors_table'];
                    let index = index
                  "
                  style="width: 50%;"
                >
                  <!-- <span>{{trainings[data['id']]['value']}}</span> -->
                  <mat-select
                    class="coaching-plan-training-status-input"
                    [(ngModel)]="trainings[data['id']]['status_id']"
                    (selectionChange)="changeTrainingStatus(trainings, data)"
                    [disabled]="action_type == 'View'"
                  >
                    <mat-option
                      *ngFor="let status of status_list"
                      [value]="status.id"
                      >{{ status.name }}</mat-option
                    >
                  </mat-select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="manage-plan-loader" *ngIf="!selected_coaching_plan_data_loaded">
        <app-loader [loading_text]="'Loading'"></app-loader>
      </div>
    </div>
  </div>
  